<header
    class="header"
    [class._default-height]="hideHeaderPromo()"
    [lsUiClassOnScroll]="50"
>
    <div class="header__content container">
        <button
            class="header__menu-button"
            lsUiButtonKind="subtle"
            lsUiButtonPalette="neutral-1"
            lsUiButtonSize="small"
            [hasIcon]="true"
            [name]="'common.button-menu' | translate"
            (click)="toggleMenu()"
        >
            <ls-ui-icon
                height="24"
                src="menu"
                width="24"
            />
        </button>

        <a
            class="header__logo"
            [routerLink]="'/' | localize"
            (click)="closeMenu()"
        >
            <ls-picture
                alt="AVOCASINO"
                [breakpoint]="logoBreakpoint"
                [height]="42"
                [src]="`event-themes/${eventTheme}/images/logo-desktop`"
                [srcMobile]="`event-themes/${eventTheme}/images/logo-mobile`"
                [width]="isMobileLogo ? 124 : 166"
            />
        </a>

        <nav class="header__nav">
            @for (link of headerLinks; track $index) {
                @if (link.url) {
                    <a
                        class="header__nav-link link _subtle-light _graphic-link-header"
                        routerLinkActive="_selected"
                        [routerLink]="[link.url | localize]"
                    >
                        {{ link.name | translate }}
                    </a>
                }
            }
        </nav>

        <div
            #uiClassOnScroll="uiClassOnScroll"
            #user="user"
            class="header__actions"
            lsUser
            [lsUiClassOnScroll]="500"
        >
            <ng-container *lsUiNgLet="user.userLoadingStatus$ | async as userLoadingStatus">
                @if (userLoadingStatus === userViewStatuses.NO_USER) {
                    <button
                        lsUiButtonKind="primary"
                        lsUiButtonSize="small"
                        [class._themed]="eventTheme | checkEventThemePipe"
                        [lsUiButtonPalette]="(uiClassOnScroll.isScrolled && !wasLoggedIn) ? 'accent-1' : 'accent-1'"
                        [name]="'common.button-register' | translate"
                        (click)="registration()"
                    >
                        {{ 'common.button-register' | translate }}
                    </button>

                    <button
                        lsUiButtonSize="small"
                        [lsUiButtonKind]="wasLoggedIn ? 'subtle' : 'subtle'"
                        [lsUiButtonPalette]="wasLoggedIn ? 'neutral-1' : 'neutral-1'"
                        [name]="'common.button-log-in' | translate"
                        (click)="login()"
                    >
                        {{ 'common.button-log-in' | translate }}
                    </button>
                }

                @if (userLoadingStatus === userViewStatuses.LOADED) {
                    <ls-profile-balance/>
                    <ls-profile [isProfilePage]="isProfilePage()"/>
                }
            </ng-container>
        </div>
    </div>

    <!--    @if (!hideHeaderPromo()) {-->
    <!--        <div class="header__aviator-wrapper container">-->
    <!--            <a-->
    <!--                class="header__aviator"-->
    <!--                [routerLink]="['/game/aviator-spribe' | localize]"-->
    <!--            >-->
    <!--                <img-->
    <!--                    class="header__aviator-img"-->
    <!--                    [src]="(cdn | resolveUrlMirror) + '/images/aviator/pic.svg'"-->
    <!--                    alt="Aviator"-->
    <!--                >-->
    <!--            </a>-->
    <!--        </div>-->
    <!--    }-->
</header>
